module.exports = __webpack_public_path__ + "img/Screenshot-12.cb9e4f9e.png";